// extracted by mini-css-extract-plugin
export default {"content":"song_content__Eil6O","link":"song_link__7N59q"};